<div fxLayout="column" fxLayoutAlign="start stretch" *ngIf="ViewReady">
    <button
        type="button"
        *ngIf="ParamsPreviousPage === 'search' && LastSearchResults != null && LastSearchOptions != null"
        mat-raised-button
        color="accent"
        (click)="HandleSearchReturn()"
    >
        Back to Search Results
    </button>
    <div *ngIf="UnableToView">
        The IRIS request that you have requested to view is currently unavailable. We apologize for the inconvenience.
    </div>
    <h2 *ngIf="!UnableToView" class="mat-headline">
        Request #{{ LoadedRequest?.RequestIssueNumber | requestIssue: LoadedRequest?.FiscalYear }}
    </h2>
    <div *ngIf="!UnableToView" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="0px" fxLayoutGap.lt-md="10px">
        <div
            fxLayout="row"
            fxLayoutAlign="start center"
            fxLayoutGap="30px"
            fxLayout.lt-md="column"
            fxLayoutAlign.lt-md="start stretch"
            fxLayoutGap.lt-md="10px"
        >
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" fxFlex="40">
                <app-form-label>Subject:</app-form-label>
                <div>{{ LoadedRequest?.Subject }}</div>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
                <app-form-label>Current Status:</app-form-label>
                <div>{{ LoadedRequest?.StatusLabel }}</div>
            </div>
        </div>
        <div
            fxLayout="row"
            fxLayoutAlign="start center"
            fxLayoutGap="30px"
            fxLayout.lt-md="column"
            fxLayoutAlign.lt-md="start stretch"
            fxLayoutGap.lt-md="10px"
        >
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" fxFlex="40">
                <app-form-label>Category:</app-form-label>
                <div *ngIf="LoadedRequest?.CategoryID != null">{{ LoadedRequest?.CategoryID | category: AllCategories }}</div>
                <div *ngIf="LoadedRequest?.CategoryID == null">N/A</div>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
                <app-form-label>Opened:</app-form-label>
                <div>{{ LoadedRequest?.DateCreated | date: 'M/d/yyyy h:mm a' }}</div>
            </div>
        </div>
        <div
            fxLayout="row"
            fxLayoutAlign="start center"
            fxLayoutGap="30px"
            fxLayout.lt-md="column"
            fxLayoutAlign.lt-md="start stretch"
            fxLayoutGap.lt-md="10px"
        >
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" fxFlex="40">
                <app-form-label>Requestor:</app-form-label>
                <div>{{ LoadedRequest?.RequestorInfo?.FullName | titleCase }}</div>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
                <app-form-label>Priority:</app-form-label>
                <div>{{ LoadedRequest?.Priority | priority }}</div>
            </div>
        </div>
        <div
            fxLayout="row"
            fxLayoutAlign="start center"
            fxLayoutGap="30px"
            fxLayout.lt-md="column"
            fxLayoutAlign.lt-md="start stretch"
            fxLayoutGap.lt-md="10px"
        >
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" fxFlex="40">
                <app-form-label>School:</app-form-label>
                <div *ngIf="LoadedRequest?.SchoolNumber">{{ LoadedRequest?.SchoolNumber | schoolName: AllSchools:true }}</div>
                <div *ngIf="!LoadedRequest?.SchoolNumber">N/A</div>
            </div>
            <div *ngIf="!AsBoard" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
                <app-form-label>Due:</app-form-label>
                <div *ngIf="LoadedRequest?.DueDate != null">{{ LoadedRequest?.DueDate | date: 'M/d/yyyy' }}</div>
                <div *ngIf="LoadedRequest?.DueDate == null">Not Assigned</div>
            </div>
            <div *ngIf="AsBoard" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
                <app-form-label>Closed:</app-form-label>
                <div *ngIf="LoadedRequest?.RequestIsClosed">{{ LoadedRequest?.DateClosed | date: 'M/d/yyyy h:mm a' }}</div>
                <div *ngIf="LoadedRequest?.RequestIsClosed !== true">
                    <span *ngIf="LoadedRequest?.Status !== 'FOLLOWUP'">N/A</span>
                    <span *ngIf="LoadedRequest?.Status === 'FOLLOWUP'">Follow-Up Pending</span>
                </div>
            </div>
        </div>
        <div
            fxLayout="row"
            fxLayoutAlign="start center"
            fxLayoutGap="30px"
            fxLayout.lt-md="column"
            fxLayoutAlign.lt-md="start stretch"
            fxLayoutGap.lt-md="10px"
        >
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" fxFlex="40">
                <app-form-label>Board District:</app-form-label>
                <div *ngIf="LoadedRequest?.BoardDistrict">District {{ LoadedRequest?.BoardDistrict }}</div>
                <div *ngIf="!LoadedRequest?.BoardDistrict">All / District-Wide</div>
            </div>
            <div *ngIf="!AsBoard" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
                <app-form-label>Closed:</app-form-label>
                <div *ngIf="LoadedRequest?.RequestIsClosed || LoadedRequest?.Status === 'FOLLOWUP'">
                    <span>{{ LoadedRequest?.DateClosed | date: 'M/d/yyyy h:mm a' }}</span>
                    <span *ngIf="LoadedRequest?.ActualJobTime != null">
                        ({{ LoadedRequest?.ActualJobTime | number: '1.1-1' }} hrs worked)</span
                    >
                </div>
                <div *ngIf="LoadedRequest?.RequestIsClosed !== true">
                    <span *ngIf="LoadedRequest?.Status !== 'FOLLOWUP'">N/A</span>
                    <span *ngIf="LoadedRequest?.Status === 'FOLLOWUP'">Follow-Up Pending</span>
                </div>
            </div>
            <div
                *ngIf="AsBoard && (LoadedRequest?.RequestIsClosed || LoadedRequest?.Status === 'FOLLOWUP')"
                fxLayout="row"
                fxLayoutAlign="start center"
                fxLayoutGap="15px"
            >
                <app-form-label>Hours Worked:</app-form-label>
                <div>{{ LoadedRequest?.ActualJobTime | number: '1.1-1' }} hrs</div>
            </div>
        </div>
        <div
            *ngIf="
                User.CurrentRole === 'Cabinet' ||
                User.CurrentRole === 'Responder' ||
                User.CurrentRole === 'Facilitator' ||
                User.CurrentRole === 'Developer' ||
                User.CurrentRole === 'Superintendent' ||
                User.CurrentRole === 'DeputySuperintendent'
            "
            fxLayout="row"
            fxLayoutAlign="start center"
            fxLayoutGap.gt-sm="30px"
            fxLayout.lt-md="column"
            fxLayoutAlign.lt-md="start stretch"
        >
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" fxFlex.gt-sm="40" fxFlex="100">
                <app-form-label>Board Member:</app-form-label>
                <div>
                    {{ LoadedRequest?.RequestorInfo?.FirstName | titleCase }} {{ LoadedRequest?.RequestorInfo?.LastName | titleCase }}
                </div>
            </div>
        </div>
        <div
            *ngIf="
                (LoadedRequest?.ConstituentPrivate !== true || LoadedRequest?.RequestedBySAPID === User.SAPID) &&
                (LoadedRequest?.ConstituentName || LoadedRequest?.ConstituentEmail || LoadedRequest?.ConstituentPhone)
            "
            fxLayout="row"
            fxLayoutAlign="start center"
            fxLayoutGap="30px"
            fxLayout.lt-md="column"
            fxLayoutAlign.lt-md="start stretch"
            fxLayoutGap.lt-md="10px"
        >
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" fxFlex="40">
                <app-form-label>Constituent Name:</app-form-label>
                <div *ngIf="LoadedRequest?.ConstituentName">{{ LoadedRequest?.ConstituentName }}</div>
                <div *ngIf="!LoadedRequest?.ConstituentName">N/A</div>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
                <app-form-label>Constituent Email:</app-form-label>
                <div *ngIf="LoadedRequest?.ConstituentEmail">{{ LoadedRequest?.ConstituentEmail }}</div>
                <div *ngIf="!LoadedRequest?.ConstituentEmail">N/A</div>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
                <app-form-label>Constituent Phone:</app-form-label>
                <div *ngIf="LoadedRequest?.ConstituentPhone">{{ LoadedRequest?.ConstituentPhone | phone: 'parens' }}</div>
                <div *ngIf="!LoadedRequest?.ConstituentPhone">N/A</div>
            </div>
        </div>
        <section [hidden]="SmallSize" class="mat-elevation-z5">
            <mat-tab-group [(selectedIndex)]="SelectedTabIndex" [dynamicHeight]="true">
                <mat-tab>
                    <ng-template mat-tab-label>Request / Concern</ng-template>
                    <div fxLayout="column" fxLayoutAlign="start stretch" class="padding-top">
                        <div>This is the request / concern entered by the original creator of the request:</div>
                        <div class="usertext">{{ LoadedRequest?.RequestText }}</div>
                        <div *ngIf="LoadedRequest?.Confidential">
                            <strong
                                >Note: This request has been marked as containing confidential student and/or parent
                                information.</strong
                            >
                        </div>
                        <div
                            *ngIf="LoadedRequest?.RequestAttachments && !!LoadedRequest?.RequestAttachments?.length"
                            fxLayout="column"
                            fxLayoutAlign="start stretch"
                            fxLayoutGap="15px"
                        >
                            <div>The following file(s) were attached to this request by the request creator:</div>
                            <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="30px">
                                <div
                                    fxLayout="column"
                                    fxLayoutAlign="start center"
                                    *ngFor="let file of LoadedRequest?.RequestAttachments"
                                >
                                    <button type="button" mat-raised-button color="primary" (click)="HandleFileAttachment(file)">
                                        <mat-icon matPrefix>cloud_download</mat-icon>
                                        <span>{{ file.FileName }}</span>
                                    </button>
                                    <span>{{ file.FileSize | fileSize: 2 }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab
                    *ngIf="
                        (User.CurrentRole !== 'BoardMember' && User.CurrentRole !== 'BoardAssistant') ||
                        LoadedRequest?.Completed === true
                    "
                >
                    <ng-template mat-tab-label>Resolution / Response</ng-template>
                    <div fxLayout="column" fxLayoutAlign="start stretch" class="padding-top">
                        <div *ngIf="LoadedRequest?.Status === 'DENIED'">
                            There was no response provided to this request. The request was closed because the amount of time required
                            to complete the request was not approved.
                        </div>
                        <div *ngIf="LoadedRequest?.Status !== 'DENIED'">
                            <div>
                                <em>
                                    <span *ngIf="LoadedRequest?.Responses && LoadedRequest?.Responses.length > 1" class="margin-bottom"
                                        >The following responses were provided by individuals responding to this request:</span
                                    >
                                    <span
                                        *ngIf="LoadedRequest?.Responses && LoadedRequest?.Responses.length === 1"
                                        class="margin-bottom"
                                        >The following response was provided by the individual responding to this request:</span
                                    >
                                </em>
                            </div>
                            <div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="15px">
                                <ng-container *ngFor="let item of LoadedRequest?.Responses">
                                    <div>
                                        <div *ngIf="item.ResponderFirstName && item.ResponderLastName">
                                            <strong
                                                >Response provided by {{ item.ResponderFirstName | titleCase }}
                                                {{ item.ResponderLastName | titleCase
                                                }}<span *ngIf="item.ResponderLocalJobTitle"> ({{ item.ResponderLocalJobTitle }})</span
                                                >:</strong
                                            >
                                        </div>
                                        <div class="usertext">{{ item.Response }}</div>
                                    </div>
                                    <div *ngIf="item.Confidential">
                                        <strong
                                            >Note: The responder has indicated that this response contains confidential student and/or
                                            parent information.</strong
                                        >
                                    </div>
                                </ng-container>
                                <div *ngIf="LoadedRequest?.ResponseAttachments && !!LoadedRequest?.ResponseAttachments?.length">
                                    <div>The following file(s) were attached as part of the response to this request:</div>
                                    <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="30px">
                                        <div fxLayout="column" fxLayoutAlign="start center">
                                            <ng-container *ngFor="let file of LoadedRequest?.ResponseAttachments">
                                                <button
                                                    type="button"
                                                    mat-raised-button
                                                    color="primary"
                                                    (click)="HandleFileAttachment(file)"
                                                >
                                                    <mat-icon matPrefix>cloud_download</mat-icon>
                                                    <span>{{ file.FileName }}</span>
                                                </button>
                                                <span>{{ file.FileSize | fileSize: 2 }}</span>
                                            </ng-container>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        fxLayout="column"
                        fxLayoutAlign="start stretch"
                        *ngIf="LoadedRequest?.RequestIsClosed !== true && LoadedRequest?.Status !== 'FOLLOWUP'"
                        class="padding-top"
                    >
                        <div><em>This request has not yet been responded to.</em></div>
                    </div>
                    <div class="margin-top" *ngIf="CanFollowUp" fxLayout="row" fxLayoutAlign="center center">
                        <button type="button" mat-raised-button color="accent" (click)="RequestFollowUp()">
                            Ask Follow-Up Question About This Response
                        </button>
                    </div>
                </mat-tab>
                <mat-tab *ngIf="LoadedRequest?.Comments && !!LoadedRequest?.Comments.length">
                    <ng-template mat-tab-label> <span>Internal Request Notes</span> </ng-template>
                    <div fxLayout="column" fxLayoutAlign="start stretch" class="padding-top">
                        <div>
                            The following internal notes have been attached to this referral by previous handlers of the request:
                        </div>
                        <table mat-table [dataSource]="CommentsData" matSort matSortActive="DateCommentAdded" matSortDirection="desc">
                            <ng-container matColumnDef="DateCommentAdded">
                                <th mat-header-cell *matHeaderCellDef>Comment Date</th>
                                <td mat-cell *matCellDef="let com">
                                    <div>{{ com.DateCommentAdded | date: 'M/d/yyyy h:mm a' }}</div>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="Comment">
                                <th mat-header-cell *matHeaderCellDef>Comment</th>
                                <td mat-cell *matCellDef="let com"><div [innerHTML]="com.Comment"></div></td>
                            </ng-container>

                            <ng-container matColumnDef="CommentCreatorFullName">
                                <th mat-header-cell *matHeaderCellDef>Comment Source</th>
                                <td mat-cell *matCellDef="let com">
                                    <div>{{ com.CommentCreatorFullName | titleCase }}</div>
                                    <div>{{ com.CommentCreatorLocalJobTitle }}</div>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="CommentRecipientFullName">
                                <th mat-header-cell *matHeaderCellDef>Comment Recipient</th>
                                <td mat-cell *matCellDef="let com">
                                    <div>{{ com.CommentRecipientFullName | titleCase }}</div>
                                    <div>{{ com.CommentRecipientLocalJobTitle }}</div>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="SmallSize">
                                <th mat-header-cell *matHeaderCellDef>Comments</th>
                                <td mat-cell *matCellDef="let com">
                                    <div fxLayout="column" fxLayoutAlign="start stretch">
                                        <div fxLayout="row" fxLayoutAlign="space-between start">
                                            <div>Comment Date:</div>
                                            <div>{{ com.DateCommentAdded | date: 'M/d/yyyy h:mm a' }}</div>
                                        </div>
                                        <div fxLayout="row" fxLayoutAlign="space-between start">
                                            <div>Commenter:</div>
                                            <div>{{ com.CommentCreatorFullName | titleCase }}</div>
                                        </div>
                                        <div fxLayout="column" fxLayoutAlign="start stretch">
                                            <div>Comment:</div>
                                            <div [innerHTML]="com.Comment"></div>
                                        </div>
                                    </div>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="CommentsVisibleHeaders"></tr>
                            <tr
                                mat-row
                                *matRowDef="let com; columns: CommentsVisibleColumns; let $even = even"
                                [class.primarybackground50]="$even"
                            ></tr>
                        </table>
                    </div>
                </mat-tab>
                <mat-tab *ngIf="LoadedRequest?.FollowUps && LoadedRequest?.FollowUps.length">
                    <ng-template mat-tab-label>Follow-Up Request</ng-template>
                    <div fxLayout="column" fxLayoutAlign="start stretch" class="padding-top">
                        <div>
                            This is the follow-up question / text entered by the original creator of the request at
                            {{ (LoadedRequest?.FollowUps)[0].DateRequested | date: 'M/d/yyyy h:mm a' }}:
                        </div>
                        <div class="usertext">{{ (LoadedRequest?.FollowUps)[0].FollowUpQuestion }}</div>
                        <div *ngIf="!(LoadedRequest?.FollowUps)[0].Response">
                            <em>There is no response provided to this follow-up question / text at this time.</em>
                        </div>
                        <div *ngIf="(LoadedRequest?.FollowUps)[0].Response">
                            <em
                                >The following response was provided by
                                <strong
                                    >{{ (LoadedRequest?.FollowUps)[0].RespondedByFullName | titleCase
                                    }}<span *ngIf="(LoadedRequest?.FollowUps)[0].RespondedByLocalJobTitle">
                                        ({{ (LoadedRequest?.FollowUps)[0].RespondedByLocalJobTitle }})</span
                                    ></strong
                                >
                                on {{ (LoadedRequest?.FollowUps)[0].DateResponded | date: 'M/d/yyyy h:mm a' }}:</em
                            >
                            <div class="usertext">{{ (LoadedRequest?.FollowUps)[0].Response }}</div>
                        </div>
                        <ng-container
                            *ngIf="
                                ['COMPLETED', 'DENIED', 'UNAVAIL', 'DONEWINFO', 'DONENOINFO', 'CLOSEDNONINFO'].includes(
                                    LoadedRequest?.Status
                                ) && LoadedRequest?.FollowUpAttachments?.length
                            "
                        >
                            <div>
                                <span>The following file attachments were attached to the response to this follow-up request:</span>
                            </div>
                            <table class="mat-table fullwidth margin-top row-margin">
                                <thead>
                                    <tr class="mat-header-row">
                                        <th class="mat-header-cell">File Name</th>
                                        <th class="mat-header-cell centered">File Size</th>
                                        <th class="mat-header-cell centered">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="mat-row" *ngFor="let item of LoadedRequest?.FollowUpAttachments; index as $index">
                                        <td class="mat-cell">
                                            <div>{{ item.FileName }}</div>
                                        </td>
                                        <td class="mat-cell centered">
                                            <div>{{ item.FileSize | fileSize }}</div>
                                        </td>
                                        <td class="mat-cell">
                                            <div fxLayout="row" fxLayoutAlign="center center">
                                                <button
                                                    type="button"
                                                    mat-raised-button
                                                    color="primary"
                                                    (click)="HandleFileAttachment(item)"
                                                >
                                                    Download
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr class="mat-row" *ngIf="!LoadedRequest?.FollowUpAttachments?.length">
                                        <td class="mat-cell" colspan="3">
                                            <em>There are no files attached to the response to this follow-up request.</em>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </ng-container>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </section>
        <mat-accordion *ngIf="SmallSize" [multi]="true">
            <mat-expansion-panel [expanded]="true">
                <mat-expansion-panel-header> <mat-panel-title> Request / Concern </mat-panel-title> </mat-expansion-panel-header>
                <div fxLayout="column" fxLayoutAlign="start stretch" class="padding-top">
                    <div>This is the request / concern entered by the original creator of the request:</div>
                    <div class="usertext">{{ LoadedRequest?.RequestText }}</div>
                    <div *ngIf="LoadedRequest?.Confidential">
                        <strong
                            >Note: This request has been marked as containing confidential student and/or parent information.</strong
                        >
                    </div>
                    <div
                        *ngIf="LoadedRequest?.RequestAttachments && !!LoadedRequest?.RequestAttachments?.length"
                        fxLayout="column"
                        fxLayoutAlign="start stretch"
                        fxLayoutGap="15px"
                    >
                        <div>The following file(s) were attached to this request by the request creator:</div>
                        <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="30px">
                            <div fxLayout="column" fxLayoutAlign="start center" *ngFor="let file of LoadedRequest?.RequestAttachments">
                                <button type="button" mat-raised-button color="primary" (click)="HandleFileAttachment(file)">
                                    <mat-icon matPrefix>cloud_download</mat-icon>
                                    <span>{{ file.FileName }}</span>
                                </button>
                                <span>{{ file.FileSize | fileSize: 2 }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-expansion-panel>
            <mat-expansion-panel
                *ngIf="
                    (User.CurrentRole !== 'BoardMember' && User.CurrentRole !== 'BoardAssistant') || LoadedRequest?.Completed === true
                "
                [expanded]="true"
            >
                <mat-expansion-panel-header> <mat-panel-title> Resolution / Response </mat-panel-title> </mat-expansion-panel-header>
                <div fxLayout="column" fxLayoutAlign="start stretch" class="padding-top">
                    <div *ngIf="LoadedRequest?.Status === 'DENIED'">
                        There was no response provided to this request. The request was closed because the amount of time required to
                        complete the request was not approved.
                    </div>
                    <div *ngIf="LoadedRequest?.Status !== 'DENIED'">
                        <div>
                            <em>
                                <span *ngIf="LoadedRequest?.Responses && LoadedRequest?.Responses.length > 1" class="margin-bottom"
                                    >The following responses were provided by individuals responding to this request:</span
                                >
                                <span *ngIf="LoadedRequest?.Responses && LoadedRequest?.Responses.length === 1" class="margin-bottom"
                                    >The following response was provided by the individual responding to this request:</span
                                >
                            </em>
                        </div>
                        <div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="15px">
                            <ng-container *ngFor="let item of LoadedRequest?.Responses">
                                <div>
                                    <div *ngIf="item.ResponderFirstName && item.ResponderLastName">
                                        <strong
                                            >Response provided by {{ item.ResponderFirstName | titleCase }}
                                            {{ item.ResponderLastName | titleCase
                                            }}<span *ngIf="item.ResponderLocalJobTitle"> ({{ item.ResponderLocalJobTitle }})</span
                                            >:</strong
                                        >
                                    </div>
                                    <div class="usertext">{{ item.Response }}</div>
                                </div>
                                <div *ngIf="item.Confidential">
                                    <strong
                                        >Note: The responder has indicated that this response contains confidential student and/or
                                        parent information.</strong
                                    >
                                </div>
                            </ng-container>
                            <div *ngIf="LoadedRequest?.ResponseAttachments && !!LoadedRequest?.ResponseAttachments?.length">
                                <div>The following file(s) were attached as part of the response to this request:</div>
                                <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="30px">
                                    <div fxLayout="column" fxLayoutAlign="start center">
                                        <ng-container *ngFor="let file of LoadedRequest?.ResponseAttachments">
                                            <button
                                                type="button"
                                                mat-raised-button
                                                color="primary"
                                                (click)="HandleFileAttachment(file)"
                                            >
                                                <mat-icon matPrefix>cloud_download</mat-icon>
                                                <span>{{ file.FileName }}</span>
                                            </button>
                                            <span>{{ file.FileSize | fileSize: 2 }}</span>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    fxLayout="column"
                    fxLayoutAlign="start stretch"
                    *ngIf="LoadedRequest?.RequestIsClosed !== true && LoadedRequest?.Status !== 'FOLLOWUP'"
                    class="padding-top"
                >
                    <div><em>This request has not yet been responded to.</em></div>
                </div>
                <div class="margin-top" *ngIf="CanFollowUp" fxLayout="row" fxLayoutAlign="center center">
                    <button type="button" mat-raised-button color="accent" (click)="RequestFollowUp()">
                        Ask Follow-Up Question About This Response
                    </button>
                </div>
            </mat-expansion-panel>
            <mat-expansion-panel *ngIf="LoadedRequest?.Comments && !!LoadedRequest?.Comments.length" [expanded]="true">
                <mat-expansion-panel-header> <mat-panel-title> Internal Request Notes </mat-panel-title> </mat-expansion-panel-header>
                <div fxLayout="column" fxLayoutAlign="start stretch" class="padding-top">
                    <div>The following internal notes have been attached to this referral by previous handlers of the request:</div>
                    <table mat-table [dataSource]="CommentsData" matSort matSortActive="DateCommentAdded" matSortDirection="desc">
                        <ng-container matColumnDef="DateCommentAdded">
                            <th mat-header-cell *matHeaderCellDef>Comment Date</th>
                            <td mat-cell *matCellDef="let com">
                                <div>{{ com.DateCommentAdded | date: 'M/d/yyyy h:mm a' }}</div>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="Comment">
                            <th mat-header-cell *matHeaderCellDef>Comment</th>
                            <td mat-cell *matCellDef="let com"><div [innerHTML]="com.Comment"></div></td>
                        </ng-container>

                        <ng-container matColumnDef="CommentCreatorFullName">
                            <th mat-header-cell *matHeaderCellDef>Comment Source</th>
                            <td mat-cell *matCellDef="let com">
                                <div>{{ com.CommentCreatorFullName | titleCase }}</div>
                                <div>{{ com.CommentCreatorLocalJobTitle }}</div>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="CommentRecipientFullName">
                            <th mat-header-cell *matHeaderCellDef>Comment Recipient</th>
                            <td mat-cell *matCellDef="let com">
                                <div>{{ com.CommentRecipientFullName | titleCase }}</div>
                                <div>{{ com.CommentRecipientLocalJobTitle }}</div>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="SmallSize">
                            <th mat-header-cell *matHeaderCellDef>Comments</th>
                            <td mat-cell *matCellDef="let com">
                                <div fxLayout="column" fxLayoutAlign="start stretch">
                                    <div fxLayout="row" fxLayoutAlign="space-between start">
                                        <div>Comment Date:</div>
                                        <div>{{ com.DateCommentAdded | date: 'M/d/yyyy h:mm a' }}</div>
                                    </div>
                                    <div fxLayout="row" fxLayoutAlign="space-between start">
                                        <div>Commenter:</div>
                                        <div>{{ com.CommentCreatorFullName | titleCase }}</div>
                                    </div>
                                    <div fxLayout="column" fxLayoutAlign="start stretch">
                                        <div>Comment:</div>
                                        <div [innerHTML]="com.Comment"></div>
                                    </div>
                                </div>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="CommentsVisibleHeaders"></tr>
                        <tr
                            mat-row
                            *matRowDef="let com; columns: CommentsVisibleColumns; let $even = even"
                            [class.primarybackground50]="$even"
                        ></tr>
                    </table>
                </div>
            </mat-expansion-panel>
            <mat-expansion-panel *ngIf="LoadedRequest?.FollowUps && LoadedRequest?.FollowUps.length" [expanded]="true">
                <mat-expansion-panel-header> <mat-panel-title>Follow-Up Request</mat-panel-title> </mat-expansion-panel-header>
                <div fxLayout="column" fxLayoutAlign="start stretch" class="padding-top">
                    <div>
                        This is the follow-up question / text entered by the original creator of the request at
                        {{ (LoadedRequest?.FollowUps)[0].DateRequested | date: 'M/d/yyyy h:mm a' }}:
                    </div>
                    <div class="usertext">{{ (LoadedRequest?.FollowUps)[0].FollowUpQuestion }}</div>
                    <div *ngIf="!(LoadedRequest?.FollowUps)[0].Response">
                        <em>There is no response provided to this follow-up question / text at this time.</em>
                    </div>
                    <div *ngIf="(LoadedRequest?.FollowUps)[0].Response">
                        <em
                            >The following response was provided by
                            <strong
                                >{{ (LoadedRequest?.FollowUps)[0].RespondedByFullName | titleCase
                                }}<span *ngIf="(LoadedRequest?.FollowUps)[0].RespondedByLocalJobTitle">
                                    ({{ (LoadedRequest?.FollowUps)[0].RespondedByLocalJobTitle }})</span
                                ></strong
                            >
                            on {{ (LoadedRequest?.FollowUps)[0].DateResponded | date: 'M/d/yyyy h:mm a' }}:</em
                        >
                        <div class="usertext">{{ (LoadedRequest?.FollowUps)[0].Response }}</div>
                        <ng-container
                            *ngIf="
                                ['COMPLETED', 'DENIED', 'UNAVAIL', 'DONEWINFO', 'DONENOINFO', 'CLOSEDNONINFO'].includes(
                                    LoadedRequest?.Status
                                ) && LoadedRequest?.FollowUpAttachments?.length
                            "
                        >
                            <div>
                                <span>The following file attachments were attached to the response to this follow-up request:</span>
                            </div>
                            <table class="mat-table fullwidth margin-top row-margin">
                                <thead>
                                    <tr class="mat-header-row">
                                        <th class="mat-header-cell">File Name</th>
                                        <th class="mat-header-cell centered">File Size</th>
                                        <th class="mat-header-cell centered">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="mat-row" *ngFor="let item of LoadedRequest?.FollowUpAttachments; index as $index">
                                        <td class="mat-cell">
                                            <div>{{ item.FileName }}</div>
                                        </td>
                                        <td class="mat-cell centered">
                                            <div>{{ item.FileSize | fileSize }}</div>
                                        </td>
                                        <td class="mat-cell">
                                            <div fxLayout="row" fxLayoutAlign="center center">
                                                <button
                                                    type="button"
                                                    mat-raised-button
                                                    color="primary"
                                                    (click)="HandleFileAttachment(item)"
                                                >
                                                    Download
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr class="mat-row" *ngIf="!LoadedRequest?.FollowUpAttachments?.length">
                                        <td class="mat-cell" colspan="3">
                                            <em>There are no files attached to the response to this follow-up request.</em>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </ng-container>
                    </div>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
        <div
            fxLayout="row"
            fxLayoutAlign="center center"
            fxLayoutGap="15px"
            class="actionbar"
            *ngIf="LoadedRequest?.ReferralIsClosed !== true && LoadedRequest?.Cancelled !== true && LoadedRequest?.Completed !== true"
        >
            <button
                type="button"
                *ngIf="
                    (User.CurrentRole === 'BoardMember' && LoadedRequest?.RequestedBySAPID === User.SAPID) ||
                    (User.CurrentRole === 'BoardAssistant' && LoadedRequest?.Source === 0) ||
                    (User.CurrentRole === 'Facilitator' && LoadedRequest?.Source === 1)
                "
                mat-raised-button
                color="warn"
                (click)="HandleCancelRequest()"
            >
                Cancel This Request
            </button>
        </div>
    </div>
</div>
